export  enum TipoRespuesta {
    Exito,
    Advertencia,
    Error
  }